import { UserManager } from 'oidc-client-ts';
import type { UserManagerSettings } from 'oidc-client-ts';

// KC 25 no longer uses the /auth context path. Nginx proxies /realms/* directly to Keycloak,
// so the authority base is just the origin. For local dev, use localhost:8080 directly.
const isProduction = import.meta.env.PROD;
const isDomainAccess = typeof window !== 'undefined' && 
  window.location.hostname !== 'localhost' && 
  window.location.hostname !== '127.0.0.1';

const keycloakUrl = import.meta.env.VITE_KEYCLOAK_URL || 
  (isProduction || isDomainAccess ? window.location.origin : 'http://localhost:8080');

export const keycloakConfig: UserManagerSettings = {
  authority: `${keycloakUrl}/realms/iti`,
  client_id: 'iti-frontend',
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid profile email roles offline_access', // Include 'offline_access' for refresh tokens
  automaticSilentRenew: true,
  silent_redirect_uri: `${window.location.origin}/silent-renew`,
  loadUserInfo: false, // Disable to avoid CORS issues - we'll get user info from the token
};

export const userManager = new UserManager(keycloakConfig);

// Handle silent renew errors gracefully
// This prevents console errors when refresh tokens are invalid (e.g., after scope changes)
userManager.events.addSilentRenewError((error) => {
  console.warn('Silent token renewal failed. This is expected if refresh token is invalid or expired. User may need to re-login.', error);
});

// Handle user loaded events (successful renewals)
userManager.events.addUserLoaded(() => {
  console.debug('User token refreshed successfully');
});

